import React, { useState } from 'react';
import { Button, Typography, CircularProgress, Box } from '@mui/material';
import axios from 'axios';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';

const API_URL = process.env.REACT_APP_API_URL;

const SendChristmasEmailButton = () => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSend = async () => {
    setLoading(true);
    setError(null);

    try {
      await axios.post(
        `${API_URL}/send-christmas-email/`, // updated backend endpoint
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      setSent(true);
    } catch (err) {
      console.error(err);
      setError('Failed to send email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header1 />

      <Box sx={{ textAlign: 'center', m: 3 }}>
        <Typography variant="h6">
          Send Christmas Email
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSend}
          disabled={loading || sent}
          sx={{ mt: 2 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : sent ? (
            'Email Sent ✅'
          ) : (
            'Send Email'
          )}
        </Button>

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </Box>

      <Footer2 />
    </div>
  );
};

export default SendChristmasEmailButton;
